/* eslint-disable filenames/match-regex */
export const ADDON_EXTENSION = 'VVE'; // voucher validity extension
export const ADDON_PMV = 'PMV'; // protect my voucher
export const ADDON_DVP = 'DVP'; // deal voucher product

export const SECOND_CHECKOUT_SOURCE = 'second_checkout';
export const POST_CHECKOUT_SOURCE = 'my_wowcher';
